/**
 * Package upgrade names are written `{room name} – {upgrade descriptor}`. Where we name the upgrade
 * *target*, only the descriptor is wanted — the room is already stated by the row or the struck-through
 * source name above it.
 *
 * The separator must be a dash **surrounded by spaces**. Real package names contain unspaced hyphens
 * that are part of a word — `Sky Studio – All-Inclusive Upgrade`, `Swim-up Suite`, `Two-Bedroom Villa`
 * — and splitting on a bare hyphen corrupts them ("All-Inclusive Upgrade" would become
 * "Inclusive Upgrade").
 *
 * Verified against 46 live package names (3 Aug): 19 carried a separator, every one of them a spaced
 * en dash, none had more than one, and three had trailing whitespace — hence the trim.
 *
 * Where there are several separators we keep everything after the *first*, since the first dash is the
 * one dividing room from upgrade. No live name currently has more than one.
 */
const SPACED_DASH = /\s+[–—-]\s+/

function getLoyaltyUpgradeTargetDisplayName(name: string | undefined): string {
  if (!name) return ''
  const separatorIndex = name.search(SPACED_DASH)
  if (separatorIndex === -1) return name.trim()
  return name.slice(separatorIndex).replace(SPACED_DASH, '').trim()
}

export default getLoyaltyUpgradeTargetDisplayName
